import { NgModule, CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';

import { HomeRoutingModule } from './home-routing.module';
import { HomeComponent } from './home.component';
import { FormsModule } from '@angular/forms';
import { FooterModule } from '../shared/components/footer/footer.module';
import { HeaderModule } from '../shared/components/header/header.module';
import { NavigationModalModule } from '../shared/components/navigation-modal/navigation-modal.module';
import { FiltersModule } from './filters/filters.module';
// import { TierComponentModule } from './tier-component/tier-component.module';
import { ViewMoreModule } from './view-more/view-more.module';
import { MyPropertiesModule } from './my-properties/my-properties.module';
import { ViewPropertyComponent } from './view-property/view-property.component';
import {MatTabsModule} from '@angular/material/tabs';
import {NgxPaginationModule} from 'ngx-pagination';

@NgModule({
  declarations: [
    HomeComponent,
    ViewPropertyComponent, 
  ],
  imports: [
    CommonModule,
    HomeRoutingModule,
    FormsModule, 
    FooterModule,
    HeaderModule, 
    NavigationModalModule, 
    FiltersModule, 
    // TierComponentModule, 
    ViewMoreModule, 
    MyPropertiesModule,
    MatTabsModule,
    NgxPaginationModule
  ], 
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA, 
    NO_ERRORS_SCHEMA
  ]

})
export class HomeModule { }
